import { Box, makeStyles, Typography, useTheme } from "@material-ui/core";

import { Menu as MenuIcon } from "@eroad/icons/material";
import { Close, Logo360, Search } from "@eroad/icons/svg";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    width: "100%",
    height: 56,
    backgroundColor: theme.palette.mono.superDark,
    padding: theme.spacing(4),
  },
  closeIcon: {
    minWidth: 24,
    maxWidth: 24,
    flex: 1,
  },
  title: {
    color: theme.palette.mono.white,
    flex: 1,
  },
}));

export interface MobileNavHeaderProps {
  closeMenu?: boolean;
  onNavToggle?: () => void;
  onClose?: () => void;
  onLogoClick?: () => void;
  onSearchClick?: () => void;
  title?: string;
}

const MobileNavHeader = ({
  title,
  closeMenu,
  onNavToggle,
  onClose,
  onLogoClick,
  onSearchClick,
}: MobileNavHeaderProps): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme<CoretexTheme>();
  const iconFill = theme.palette.mono.white;

  const CloseIcon = () => <Close className={classes.closeIcon} fill={iconFill} onClick={onClose} />;

  let content = (
    <>
      {!closeMenu ? <MenuIcon htmlColor={iconFill} onClick={onNavToggle} /> : <CloseIcon />}
      <Logo360 fill={iconFill} onClick={onLogoClick} />
      <Search
        fill={iconFill}
        onClick={!closeMenu ? onSearchClick : undefined}
        style={{ opacity: !closeMenu ? 1 : 0 }}
      />
    </>
  );

  if (title) {
    content = (
      <>
        <Typography className={classes.title}>{title}</Typography>
        <CloseIcon />
      </>
    );
  }

  return (
    <Box data-testid="mobile-nav-header" className={classes.root}>
      {content}
    </Box>
  );
};

export default MobileNavHeader;
